import React from "react"
import AlgoliaSerpContainer from "./AlgoliaSerpContainer"
import { BreadcrumbSegment } from "../../ui/organisms/HeroBreadcrumb"
import { Tag } from "../../types/tag"
import { AlgoliaSearchController } from "./components/controller/AlgoliaSearchController"
import { AlgoliaSerpContext, SerpUi } from "./context/ui"
import { SerpContextData } from "../../aggregators/serp/types"
import { AlgoliaSerpDataContext } from "./context/data"
import { normalizeTag } from "./components/controller/state/converters"
import { ProductCategoryMappingsDict } from "../../types/serp"

interface Props {
  path?: string
  title: string
  subtitle?: React.ReactNode
  description?: React.ReactNode
  descriptionExpandable?: boolean
  intro?: React.ReactNode
  breadcrumb: BreadcrumbSegment[]
  heroLogo?: React.ReactNode
  heroBackgroundImage?: string
  heroBackgroundImageMobile?: string
  categoryCodes?: string[]
  brandCodes?: string[]
  query?: string
  excludeBrandCodes?: string[]
  promoCodes?: string[]
  minDiscountPercent?: number
  maxDiscountPercent?: number
  tags?: Tag[]
  hiddenTags?: Tag[]
  languageId: string
  contents: any
  hideHero?: boolean
  heroClassName?: string
  serpData: SerpContextData
  hideDesktopFilters?: boolean
  searchLabel?: React.ReactNode
  customCategories?: ProductCategoryMappingsDict
}

const AlgoliaSerpContainerWrapper = ({
  query,
  categoryCodes,
  brandCodes,
  promoCodes,
  excludeBrandCodes,
  minDiscountPercent,
  maxDiscountPercent,
  tags,
  hiddenTags,
  intro,
  contents,
  heroBackgroundImage,
  heroBackgroundImageMobile,
  breadcrumb,
  title,
  subtitle,
  description,
  descriptionExpandable,
  heroLogo,
  hideHero,
  heroClassName,
  serpData,
  hideDesktopFilters,
  searchLabel,
  customCategories,
}: Props) => {
  const [ui, setUi] = React.useState<SerpUi>({
    filtersModalOpen: false,
    orderByExpanded: false,
    sidebarCollapsed: false,
  })

  return (
    <AlgoliaSerpDataContext.Provider value={serpData}>
      <AlgoliaSerpContext.Provider value={ui}>
        <AlgoliaSearchController
          initialFilters={{
            query,
            brandCodes,
            excludeBrandCodes,
            categories: categoryCodes,
            tags: tags?.map(normalizeTag),
            minDiscountPercent,
            maxDiscountPercent,
            promoCodes,
          }}
          hiddenFilters={{
            tags: hiddenTags?.map(normalizeTag),
          }}
          customCategories={customCategories}
        >
          <AlgoliaSerpContainer
            breadcrumb={breadcrumb}
            heroBackgroundImage={heroBackgroundImage}
            heroBackgroundImageMobile={heroBackgroundImageMobile}
            contents={contents}
            title={title}
            subtitle={subtitle}
            description={description}
            descriptionExpandable={descriptionExpandable}
            intro={intro}
            hideHero={hideHero}
            heroLogo={heroLogo}
            heroClassName={heroClassName}
            updateUiState={(value) =>
              setUi({
                ...ui,
                ...value,
              })
            }
            hideDesktopFilters={hideDesktopFilters}
            searchLabel={searchLabel}
          />
        </AlgoliaSearchController>
      </AlgoliaSerpContext.Provider>
    </AlgoliaSerpDataContext.Provider>
  )
}

export default AlgoliaSerpContainerWrapper
